import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getActiveAnnouncements } from '../../api/announcementService';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import ReactPaginate from 'react-paginate';
import { Helmet } from 'react-helmet';

const Announcement = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchAnnouncements();
  }, [currentPage, searchTerm, startDate, endDate]);

  const fetchAnnouncements = async () => {
    try {
      setLoading(true);
      const response = await getActiveAnnouncements();
      if (response.isSuccess && response.data) {
        setAnnouncements(response.data.items);
      } else {
        setError('Duyurular yüklenirken bir hata oluştu');
      }
    } catch (error) {
      setError('Duyurular yüklenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), 'dd.MM.yyyy');
    } catch (error) {
      return dateString;
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    setCurrentPage(0);
  };

  const filteredAnnouncements = announcements.filter(announcement => {
    const matchesSearch = 
      announcement.header.toLowerCase().includes(searchTerm.toLowerCase()) ||
      announcement.department.toLowerCase().includes(searchTerm.toLowerCase());

    if (startDate && endDate) {
      const announcementDate = new Date(announcement.date);
      return matchesSearch && 
        announcementDate >= startDate &&
        announcementDate <= endDate;
    }

    return matchesSearch;
  });

  const pageCount = Math.ceil(filteredAnnouncements.length / itemsPerPage);
  const offset = currentPage * itemsPerPage;
  const currentAnnouncements = filteredAnnouncements.slice(offset, offset + itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    window.scrollTo(0, 0);
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <Link to={`/duyurular/${rowData.urlTag}`} className="btn btn-primary btn-sm" state={{ guid: rowData.guid }}>
        Detaya Git
      </Link>
    );
  };

  if (loading) {
    return (
      <div className="council-decisions">
        <div className="container">
          <h1>Duyurular</h1>
          <div className="text-center py-5">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="council-decisions">
        <div className="container">
          <h1>Duyurular</h1>
          <div className="alert alert-danger">{error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="council-decisions">
      <Helmet>
        <title>Duyurular | İskenderun Belediyesi</title>
        <meta name="description" content="İskenderun Belediyesi duyurular listesi." />
      </Helmet>
      <div className="container">
        <h1>Duyurular</h1>
        
        <div className="news-tabs-filter">
          <div className="news-tabs-filter-left">
            <div className="news-tabs-filter-left-item">
              <input 
                type="text" 
                placeholder="Duyurularda Ara" 
                value={searchTerm}
                onChange={handleSearch}
              />
              <i className="pi pi-search"></i>
            </div>
          </div>
          <div className="news-tabs-filter-right">
            <div className="news-tabs-filter-right-item">
              <DatePicker
                selected={startDate}
                onChange={handleDateChange}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                locale={tr}
                className="form-control"
                placeholderText="Tarih Aralığı"
                dateFormat="dd.MM.yyyy"
                isClearable
              />
              <i className="pi pi-calendar"></i>
            </div>
          </div>
        </div>

        <DataTable value={currentAnnouncements} className="council-table">
          <Column field="date" header="Tarih" style={{ width: '15%' }} body={(rowData) => formatDate(rowData.date)}></Column>
          <Column field="header" header="Duyuru Başlığı" style={{ width: '45%' }}></Column>
          <Column field="department" header="Birim" style={{ width: '25%' }}></Column>
          <Column body={actionBodyTemplate} header="" style={{ width: '15%' }}></Column>
        </DataTable>

        <ReactPaginate
          previousLabel="<"
          nextLabel=">"
          breakLabel="..."
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakClassName="page-item"
          breakLinkClassName="page-link"
          activeClassName="active"
        />
      </div>
    </div>
  );
};

export default Announcement;
